import React from "react";

const SportsBonuses = () => {
  return (
    <>
      <div className="py-10 text-center text-white/70 text-[12px]">There are no bonuses for selected type</div>
    </>
  );
};
export default SportsBonuses;
